module.exports = __webpack_public_path__ + "img/teach.67a5fb83.svg";